import React from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import Paragraph from 'antd/es/typography/Paragraph'
import Popover from '../../../../components/common/popover/Popover'
import Button from '../../../../components/common/button/Button'

const CreateSemanticPatternInstructions = () => {
    const content = (
        <>
            <Paragraph>Shortcuts</Paragraph>
            <Paragraph>
                <code>ctrl</code> + <code>Enter</code> - Create/Review pattern.
            </Paragraph>
        </>
    )

    return (
        <Popover content={content} title='Instructions' trigger='click' overlayStyle={{ maxWidth: 400 }}>
            <Button shape='circle' type='text' icon={<InfoCircleOutlined aria-hidden='true' />} title='Instructions' />
        </Popover>
    )
}

export default CreateSemanticPatternInstructions
